import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import { Textbox } from '@entegral/components.textbox';

export function Autocomplete({
  id,
  name,
  placeholder,
  autoComplete,

  floatingLabel,
  readOnly,

  matches,
  matchesHistory,
  query,

  baseClassName=`autocomplete`,
  extraClassName,

  onQueryChange,
  onMatchSelect,
}) {
  let [inFocus, setInFocus] = useState(false);

  let onFocusChange = useCallback(focus => setInFocus(focus), []);

  let showRegular = inFocus && matches && matches.length;
  let showHistory = !showRegular && inFocus && matchesHistory && matchesHistory.length;

  let matchesToView = showRegular ? matches : showHistory ? matchesHistory : null;

  return (
    <div className={classnames(baseClassName, extraClassName)}>
      <Textbox
        id={id}
        name={name}
        value={query}
        placeholder={placeholder}
        autoComplete={autoComplete}

        floatingLabel={floatingLabel}
        readOnly={readOnly}

        extraClassName={[`${baseClassName}__textbox`]}

        onChange={onQueryChange}
        onFocusChange={onFocusChange}
      />

      {matchesToView && (
        <div className={`${baseClassName}__matches`}>
          {
            matchesToView.map(x => (
              <Match
                key={x.id || x.term}
                match={x}
                baseClassName={baseClassName}
                onMatchSelect={onMatchSelect}
              />
            ))
          }
        </div>
      )}
    </div>
  )
}

function Match({
  name,
  match,
  baseClassName,

  onMatchSelect,
}) {
  let onMatchSelectBinded = useCallback(() => onMatchSelect(match, name), [onMatchSelect, name, match]);

  return (
    <div
      className={classnames(`${baseClassName}__match`, match.type && `${baseClassName}__match_type_${match.type}`)}
      onClick={onMatchSelectBinded}
    >
      <div className={`${baseClassName}__term`}>{match.term}</div>
      {match.subterm && <div className={`${baseClassName}__subterm`}>{match.subterm}</div>}
    </div>
  );
}
